/* global axios */
import ApiClient from './ApiClient';

class CalendarEventsAPI extends ApiClient {
  constructor() {
    super('calendar_events', { accountScoped: true });
  }

  get(since, until) {
    return axios.get(this.url, { params: { since, until } });
  }
}

export default new CalendarEventsAPI();
